import React from 'lib/react';
import { EVButton, makeStyles } from 'lib/components';
import { EV_IMAGE_FILES_PATH } from 'constants/AppConstants';
import { useTranslation } from 'lib/translation';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  // #genai Eagleview One logo button — DXF-1794 pre-login Figma node 839:9625 (~191×40, white pill, divider, ONE caps)
  horizonMenuLink: {
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '40px',
    flexShrink: 0,
    marginRight: '8px',
    padding: '8px 14px',
    borderRadius: '4px',
    border: `1px solid ${theme.evPalette.charcoal[400]}`,
    backgroundColor: theme.evPalette.salt[100],
    textDecoration: 'none',
    boxShadow: 'none',
    minWidth: 'unset',
    textTransform: 'none',
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: theme.evPalette.charcoal[100],
    },
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '-83.23%',
      right: '-247.69%',
      bottom: '-167.11%',
      left: '-8.26%',
      backgroundImage: `url(${EV_IMAGE_FILES_PATH}/HorizonTopography.svg)`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 100%',
      backgroundPosition: 'center',
      pointerEvents: 'none',
      zIndex: 0,
    },
    '& > .myev-MuiButton-label': {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    },
  },
  wordmark: {
    display: 'block',
    height: '18px',
    width: 'auto',
    flexShrink: 0,
  },
  // #genai Vertical rule between EagleView wordmark and ONE (matches Figma separator)
  divider: {
    width: '1px',
    height: '22px',
    flexShrink: 0,
    backgroundColor: theme.evPalette.charcoal[400],
  },
  oneLabel: {
    fontFamily: '"Avenir Next", "Avenir", -apple-system, BlinkMacSystemFont, sans-serif',
    height: '9px',
    fontSize: '10px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 1,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: theme.evPalette.charcoal[900],
  },
}));

export default function HorizonLink({ url }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <EVButton
      href={url}
      id="horizon-menu-item"
      className={classes.horizonMenuLink}
      aria-label={t('common__horizon')}
    >
      <img
        className={classes.wordmark}
        src={`${EV_IMAGE_FILES_PATH}/EagleViewLogoWithText.svg`}
        alt=""
      />
      <span className={classes.divider} aria-hidden />
      <span className={classes.oneLabel}>ONE</span>
    </EVButton>
  );
}

HorizonLink.propTypes = {
  url: PropTypes.string.isRequired,
};
